// MODULES
import { connect as _reduxConnect } from "react-redux";
import { bindActionCreators as _bindActionCreators } from "redux";
import moment from "moment";


export const getStandardColor = function(n) {
    const colors = {
        red: "#ff6384",
        blue: "#36a2eb",
        yellow: "#ffce56",
        green: "#4bc0c0",
        purple: "#9966ff",
        orange: "#ff9f40",
    };
    const colorName = isNaN(n) ? n : Object.keys(colors).filter((c, i) => i === n)[0];
    return colorName ? colors[colorName] || null : null;
};

export const hexToRGBA = function(hex, alpha) {
	if(hex[0] === "#") hex = hex.replace("#", "");
    if(hex.length === 3) hex = `${ hex[0] }${ hex[0] }${ hex[1] }${ hex[1] }${ hex[2] }${ hex[2] }`;
    
    const r = parseInt(hex.slice(0, 2), 16);
    const g = parseInt(hex.slice(2, 4), 16);
    const b = parseInt(hex.slice(4, 6), 16);

    if(typeof alpha === "number" && alpha < 1) {
    	return `rgba(${ r }, ${ g }, ${ b }, ${ alpha })`;
    } else {
    	return `rgba(${ r }, ${ g }, ${ b })`;
    }
};

export const inArray = function(needle, haystack) {
    for(let i = 0, n = haystack.length; i < n; i++) {
        if(haystack[i] === needle) return true;
    }
    return false;
};

export const divideString = function(str, width, spaceReplacer) {
    if(str.length > width) {
        let p = width;
        for(; p > 0 && str[p] !== ' '; p--) {}
        if(p > 0) {
            const left = str.substring(0, p);
            const right = str.substring(p+1);
            return left + spaceReplacer + divideString(right, width, spaceReplacer);
        }
    }
    return str;
};

export const createUid = function() {
	const abc = "abcdefghijklmnopqrstuvwxyz";
    const ABC = abc.toUpperCase();
    const now = (new Date()).getTime().toString();
    let result = "";
    
    for(let i = 0; i < now.length; i++) {
        const rand = Math.round(Math.random());
        result += (rand === 0 ? abc : ABC)[now[i]];
    }
    
 	return result;
};

export const handleRouteHidden = function(routeComponent, didMount) {
    return new Promise(resolve => {
        const bodyClassName = "route-" + routeComponent.constructor.name.replace("Route", "");

        if(didMount === true) {
            document.body.classList.add(bodyClassName);
            routeComponent._isMounted = true;
            routeComponent._hiddenTimeout = setTimeout(() => {
                if(routeComponent._isMounted) routeComponent.setState({ hidden: false }, resolve);
            });
        } else {
            document.body.classList.remove(bodyClassName);
            routeComponent._isMounted = false;
            clearTimeout(routeComponent._hiddenTimeout);
            routeComponent._hiddenTimeout = -1;
            resolve();
        }
    });
};

export const createDefaultFormErrorState = function() {
    return {
        message: null,
        fields: [],
    };
};

export const delay = function(duration) {
    return new Promise(resolve => {
        const timeout = setTimeout(() => resolve(timeout), duration);
    });
};

export const getAllIndexes = function(arr, val) {
    const result = [];
    for(let i = 0; i < arr.length; i++) {
        if(arr[i] === val) result.push(i);
    }
    return result;
};

export const loop = function(n, fn, mapValues = false) {
    if(mapValues === true) {
        const returnValue = [];
        for(let i = 0; i < n; i++) returnValue.push(fn(i));
        return returnValue;
    } else {
        for(let i = 0; i < n; i++) fn(i);
    }
};

export const isType = function(value, typeName) {
    return typeof value !== "undefined" && value.constructor.toString().indexOf(typeName) >= 0;
};

export const getType = function(constructor) {
    const re = /function (.{1,})\(/;
    const result = re.exec(constructor.toString());
    console.log(result);
    return (result && result.length > 1) ? result[1] : "";
};

export const validateNumber = function(value) {
    return typeof value !== "undefined" && value !== null && !isNaN(value);
};

export const validateDate = function(date, format = "YYYY-MM-DD") {
    return moment(date, format, true).isValid();
};

export const validateColor = function(color) {
    const re = /^(#[a-f0-9]{6}|#[a-f0-9]{3}|rgb *\( *[0-9]{1,3}%? *, *[0-9]{1,3}%? *, *[0-9]{1,3}%? *\)|rgba *\( *[0-9]{1,3}%? *, *[0-9]{1,3}%? *, *[0-9]{1,3}%? *, *[0-9]{1,3}%? *\)|black|green|silver|gray|olive|white|yellow|maroon|navy|red|blue|purple|teal|fuchsia|aqua)$/i;
    return re.test(color);
};

export const createClassName = function(initialClassName = "", conditionals = {}) {
    let conditionalClassName = "";
    Object.keys(conditionals).forEach(className => {
        if(!!conditionals[className]) conditionalClassName += " " + className;
    });

    return initialClassName + (initialClassName ? conditionalClassName : conditionalClassName.substring(1));
};

export const connectRedux = function(stateToProps, dispatchProps = {}, ComponentClass) {
    // const mapStateToProps = (state) => ({ reducers: { ...stateToProps(state) } });
    const mapDispatchToProps = (dispatch) => {
        const result = { actions: {}, dispatch };
        Object.keys(dispatchProps).forEach(key => result.actions[key] = _bindActionCreators(dispatchProps[key], dispatch));
        return result;
    };

    return _reduxConnect(stateToProps, mapDispatchToProps)(ComponentClass);
};

export const parseQueryString = function(query) {
    const result = {};
    if(query[0] === "?") query = query.substring(1, query.length);

    query.split("&").forEach(param => {
    	param = param.split("=");
        result[param[0]] = (() => {
        	try {
        		return JSON.parse(decodeURIComponent(param[1]));
            } catch(e) {
            	return decodeURIComponent(param[1]);
            }
        })();
    });

    return result;
};

export const createConstants = function(prefix, constants) {
    const result = {};
    constants.forEach(c => {
        const constant = `${prefix}_${c}`;
        result[c] = constant;
    });
    Object.freeze(result);
    return result;
};

export const closestInArray = function(num, arr, returnIndex = false) {
    let curr = arr[0];
    let diff = Math.abs(num - curr);
    
    for(let i = 0; i < arr.length; i++) {
        const newdiff = Math.abs(num - arr[i]);
        if(newdiff < diff) {
            diff = newdiff;
            curr = arr[i];
        }
    }

    return returnIndex === true ? arr.indexOf(curr) : curr;
};

export const getWindowDimensions = function() {
    return {
        width: window.innerWidth,
        height: window.innerHeight
    };
};

export const requestAnimFrame = (function() {
    const _raf = window.requestAnimationFrame       ||
                 window.webkitRequestAnimationFrame ||
                 window.mozRequestAnimationFrame    ||
                 function(callback) { window.setTimeout(callback, 1000 / 60) };
  return _raf ? _raf.bind(window) : null;
})();

export const animate = function(props) {
    // const duration = 1000 * props.duration;
    const duration = props.duration;
    const end = +new Date() + duration;
    
    function step() {
        const current = +new Date();
        const remaining = end - current;

        if(remaining < 60) {
            props.run(1);  // 1 = progress is at 100%
            return;
        } else {
            const rate = 1 - remaining / duration;
            props.run(rate);
        }

        requestAnimFrame(step);
    }

    step();
};

export const getClosestElementByQuery = function(elem, selector, searchItself = true) {
    if(!Element.prototype.matches) {
        Element.prototype.matches =
            Element.prototype.matchesSelector ||
            Element.prototype.mozMatchesSelector ||
            Element.prototype.msMatchesSelector ||
            Element.prototype.oMatchesSelector ||
            Element.prototype.webkitMatchesSelector ||
            function(s) {
                var matches = (this.document || this.ownerDocument).querySelectorAll(s),
                    i = matches.length;
                while (--i >= 0 && matches.item(i) !== this) {}
                return i > -1;
            };
    }

    if(searchItself === false && elem.parentNode) elem = elem.parentNode;

    for(; elem && elem !== document; elem = elem.parentNode) {
        if(elem.matches && elem.matches(selector)) return elem;
    }

    return null;
};

export const boundHorizontally = function(element, containerElement) {
    const elementRect = element.getBoundingClientRect();
    const containerElementRect = containerElement.getBoundingClientRect();

    return containerElementRect.left >= elementRect.right || containerElementRect.right <= elementRect.left;
}

export const boundVertically = function(element, containerElement) {
    const elementRect = element.getBoundingClientRect();
    const containerElementRect = containerElement.getBoundingClientRect();

    return containerElementRect.top >= elementRect.bottom || containerElementRect.bottom <= elementRect.top;
}

export const localeNumber = function(value, decimals = 2, delimiter1 = " ", delimiter2 = ",") {
    if(typeof value === "undefined" || value === null || (!value && value !== 0 && value !== "0")) {
        return localeNumber(0, decimals, delimiter1, delimiter2);
    }

	let suffix = "";
    if(typeof value === "string") {
    	const v = parseFloat(value); // Will strip any existing suffix (like units)
        suffix = value.replace(v.toString(), "");
    	value = v;
    }
    
    if(isNaN(value)) return localeNumber(0);
    
    const d = Math.pow(10, decimals);
    value = Math.round(value * d) / d;
    
    const str1 = value.toString().split(".")[0].replace(/(?!^)(?=(?:\d{3})+(?:\.|$))/gm, delimiter1);
    const str2 = (decimals > 0 ? value.toFixed(decimals) : value.toString()).split(".")[1] || null;
    
    return str1 + (str2 ? delimiter2 + str2 : "") + suffix;
};

export const parseLocaleNumber = function(value, delimiter1 = " ", delimiter2 = ",", toString = false) {
    if(typeof value === "number") return value;
    if(!value) return 0;
    const re1 = new RegExp(delimiter1, "g");
    const re2 = new RegExp(delimiter2, "g");
    if(value[value.length-1] === delimiter2) value = value + "0";

    const result = value.replace(re1, "").replace(re2, ".");
    return toString === true ? result : parseFloat(result);
};

export const capitalizeFirstLetter = word => {
  return word.charAt(0).toUpperCase() + word.slice(1);
}

// Gets the properties of an object that starts with certain prefixes
export const getPropertiesByPrefix = (obj, prefixes) => {
  const matchingProperties = {};

  for (let key in obj) {
    for (let prefix of prefixes) {
      if (key.startsWith(prefix)) {
        matchingProperties[key] = obj[key];
        break;
      }
    }
  }

  return matchingProperties;
}

const processOptionsTypeString = str =>{
  if (!str || typeof str !== 'string') return null;

  if (str.includes(',')) {
    return str.split(',').map(item => item.trim());
  } else {
    return str;
  }
}

// Iterates through an object A and returns a new object C with the same keys as object A but with updated values from keys present in object B (as appropriate following certain logic conditions)
export const parseDraftDataPropsToFieldState = (objA, objB) =>
{
    const objC = {};
    for (var key in objA)
    {
        if (objA.hasOwnProperty(key))
        {
            if (typeof objA[key] === "object" && objA[key].hasOwnProperty("options"))
            {
                // objBvalue will be a string or an array of strings or null:
                // - null if the key is not present in objB
                // - a string if the key is present in objB and the value is a string (type radio)
                // - an array of strings if the key is present in objB and the value is a string with commas (type checkbox)
                const objBvalue = processOptionsTypeString(objB[key]);
                objC[key] = {
                    options: objA[key].options.map(option =>
                    {
                        return {
                            ...option,
                            checked: objBvalue && (option.value === objBvalue || (!(typeof objBvalue === 'string' || objBvalue instanceof String) && objBvalue.includes(option.value)))
                        };
                    })
                };

                continue;
            }

            if (typeof objA[key] === "object" && objA[key].hasOwnProperty("checked"))
            {
                objC[key] = {
                    checked: objB[key] && objB[key] !== undefined && objB[key] === "yes" || objB[key] === "true" ? true : false
                };
                continue;
            }

            if (typeof objB[key] === "string" && objB[key].includes(",00kr"))
            {
                objC[key] = objB[key].replace(",00kr", "");
                continue;
            }

            if (key.includes("_date") && objB[key] !== undefined)
            {
                objC[key] = new Date(objB[key]);
                continue;
            }

            objC[key] = objB[key] !== undefined ? objB[key] : objA[key];
        }
    }
    return objC;
};

export const dateUTCtoCET = date => {
  const utcDate = new Date(date);

  // Get the UTC time in milliseconds
  const utcTime = utcDate.getTime();
  
  // Determine if the date is within daylight saving time for CEST
  const isDaylightSavingTime = (date) => {
    const year = date.getUTCFullYear();
    const dstStart = new Date(Date.UTC(year, 2, 25, 0, 0, 0)); // Last Sunday of March
    const dstEnd = new Date(Date.UTC(year, 9, 31, 0, 0, 0)); // Last Sunday of October
    return date >= dstStart && date < dstEnd;
  };
  
  // Define the CEST offset in milliseconds (UTC+2 or UTC+1 during standard time)
  const cetOffset = isDaylightSavingTime(utcDate) ? 2 * 60 * 60 * 1000 : 60 * 60 * 1000;
  
  // Calculate the CEST time by adding the offset
  const cestTime = utcTime + cetOffset;
  
  // Create a new Date object with the CEST time
  const cestDate = new Date(cestTime);

  // Return the CET date
  return cestDate;
}


// WEBPACK FOOTER //
// ./src/helpers/utils.js